import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';
import SchemaForm from 'platform/forms-system/src/js/components/SchemaForm';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChampvaEnrollmentStatus } from '../../actions';
import content from '../../locales/en/content.json';
import {
  ENROLLMENT_STATUS_KEY,
  ENROLLMENT_STATUSES,
} from '../../utils/constants';

const BeneficiaryInfoPage = ({
  contentAfterButtons,
  contentBeforeButtons,
  data = {},
  goForward,
  name,
  schema,
  setFormData,
  title,
  uiSchema,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.champvaEnrollmentStatus.loading);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = async () => {
    const { first, last } = data.applicantName || {};
    const result = await dispatch(
      fetchChampvaEnrollmentStatus({
        beneficiary: {
          firstName: first,
          lastName: last,
          dateOfBirth: data.applicantDob,
          ssn: data.applicantMemberNumber,
        },
      }),
    );
    if (!result || !isMounted.current) return;

    const formData = {
      ...data,
      [ENROLLMENT_STATUS_KEY]:
        result.enrollmentStatus ?? ENROLLMENT_STATUSES.vesError,
    };

    setFormData(formData);
    goForward({ formData });
  };

  return (
    <SchemaForm
      name={name}
      title={title}
      schema={schema}
      uiSchema={uiSchema}
      data={data}
      onChange={setFormData}
      onSubmit={handleSubmit}
    >
      <div className="vads-u-margin-y--4">
        {loading ? (
          <va-loading-indicator
            message={content['supplemental--enrollment-status-loading']}
            set-focus
          />
        ) : (
          <>
            {contentBeforeButtons}
            <FormNavButtonContinue
              submitToContinue
              useWebComponents
              enableAnalytics
            />
            {contentAfterButtons}
          </>
        )}
      </div>
    </SchemaForm>
  );
};

BeneficiaryInfoPage.propTypes = {
  goForward: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  uiSchema: PropTypes.object.isRequired,
  contentAfterButtons: PropTypes.node,
  contentBeforeButtons: PropTypes.node,
  data: PropTypes.object,
  name: PropTypes.string,
  title: PropTypes.string,
};

export default BeneficiaryInfoPage;
